import axios from 'axios';
import { InitiateCheckoutParams, InitiateCheckoutResult } from '../../../reserve';
import { useMutation, UseMutationOptions } from './useMutation';
import { useApp } from '../designs/paper/context/AppContext';

type UseInitiateCheckoutOptions = UseMutationOptions<
  Awaited<InitiateCheckoutResult>,
  Error,
  Omit<InitiateCheckoutParams, 'stripeSecretKey'>
>;

/**
 * Hook to generate a Stripe payment URL for a cart session
 * Creates a Stripe checkout session and locks all drafts
 * @param options - Mutation options
 */
export function useInitiateCheckout(options?: UseInitiateCheckoutOptions) {
  const { config } = useApp();

  return useMutation<
    Awaited<InitiateCheckoutResult>,
    Error,
    Omit<InitiateCheckoutParams, 'stripeSecretKey'>
  >(async params => {
    const response = await axios.post<InitiateCheckoutResult>(config.initiateCheckoutUrl, params);
    return response.data;
  }, options);
}
